export default __webpack_public_path__ + "images/ecdf13010a58b19d6b58ef1654a887db.png";